import { render, staticRenderFns } from "./PageCalculadoraMatriculacionCat.vue?vue&type=template&id=89aaf41a&scoped=true&"
import script from "./PageCalculadoraMatriculacionCat.vue?vue&type=script&lang=js&"
export * from "./PageCalculadoraMatriculacionCat.vue?vue&type=script&lang=js&"
import style0 from "./PageCalculadoraMatriculacionCat.vue?vue&type=style&index=0&id=89aaf41a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89aaf41a",
  null
  
)

export default component.exports